import { render, staticRenderFns } from "./AdminForm.vue?vue&type=template&id=6e4e7f26&scoped=true"
import script from "./AdminForm.vue?vue&type=script&lang=js"
export * from "./AdminForm.vue?vue&type=script&lang=js"
import style0 from "./AdminForm.vue?vue&type=style&index=0&id=6e4e7f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e7f26",
  null
  
)

export default component.exports